















import { Component, Vue } from 'vue-property-decorator';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import store from '@/store';

@Component({})
export default class Recaptcha extends Vue {
    public recaptchaNote =
        'This site is protected by reCAPTCHA and the Google <a href="{privacyPolicyLink}">Privacy Policy</a> and <a href="{termsOfServiceLink}">Terms of Service</a> apply.';

    private mounted() {
        Vue.use(VueReCaptcha, {
            siteKey: store.state.options.recaptcha.website_key,
        });
    }
}
